import React, {useEffect, useState} from 'react';
import Scrollbars from "react-custom-scrollbars-2";
import {Link, NavLink, useLocation} from "react-router-dom";


function SideNav() {
    const location = useLocation();
    const [isProductsMenuOpen, setIsProductsMenuOpen] = useState(false);
    const [isAccountsMenuOpen, setIsAccountsMenuOpen] = useState(false);

    useEffect(() => {
        if (location.pathname.startsWith('/sell')) {
            setIsProductsMenuOpen(true);
        }

        if (location.pathname.startsWith('/account') || location.pathname.startsWith('/settings')) {
            setIsAccountsMenuOpen(true);
        }
    }, [location]);

    const toggleProductsMenu = () => {
        setIsProductsMenuOpen(!isProductsMenuOpen);
    };

    const toggleAccountsMenu = () => {
        setIsAccountsMenuOpen(!isAccountsMenuOpen);
    };
    const handleMouseEnter = () => {
        document.querySelector('.left-side-menu').classList.add('expanded-on-hover');
    };

    const handleMouseLeave = () => {
        document.querySelector('.left-side-menu').classList.remove('expanded-on-hover');
    };


    return (
        <div className="left-side-menu">
            <Scrollbars style={{ height: "85vh" }}>
                <div id="sidebar-menu">
                    <ul className="metismenu" id="side-menu">
                        <li className="menu-title">Products</li>
                        <li className="side-menu" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                            <Link className="waves-effect sidenav-hover" onClick={toggleProductsMenu}>
                                <i className="remixicon-stack-line" />
                                <span> BlackX Sell </span>
                                <i className={`fa ${isProductsMenuOpen ? 'fa-angle-down' : 'fa-angle-right'}`} />
                            </Link>
                            {isProductsMenuOpen && (
                                <ul className="nav-second-level">
                                    <li className="side-nav-item">
                                        <NavLink to="/sell/products">Products</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/sell/add-on-products">Add-On Products</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/sell/product-groups">Product Groups</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/sell/customers">Customers</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/sell/cart">Cart</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/sell/coupons">Coupons</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/sell/orders">Orders</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/sell/transactions">Transactions</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/sell/invoices">Invoices</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/sell/credit-notes">Credit Notes</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/sell/refunds">Refunds</NavLink>
                                    </li>
                                </ul>
                            )}
                        </li>

                        <li className="menu-title mt-2">Account and Settings</li>

                        <li onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                            <Link className="waves-effect" onClick={toggleAccountsMenu}>
                                <i className="remixicon-layout-line" />
                                <span> Account & Settings </span>
                                <i className={`fa ${isAccountsMenuOpen ? 'fa-angle-down' : 'fa-angle-right'}`} />
                            </Link>
                            {isAccountsMenuOpen && (
                                <ul className="nav-second-level">
                                    <li>
                                        <NavLink to='/account'>Account</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to='/settings'>Settings</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to='/billing'>Billing</NavLink>
                                    </li>
                                    {/* <li>
                                        <NavLink to='/billing-v2'>Billing V2</NavLink>
                                    </li> */}
                                </ul>
                            )}
                        </li>
                    </ul>
                </div>
            </Scrollbars>
        </div>
    );
}

export default SideNav;